// @flow

import React from 'react';
import { Route, withRouter } from "react-router-dom";
import {
  ResetPassword,
  ForgotPassword,
  LoginPage
} from '../../containers/Auth';


function AuthComponent() {
    return (
      <>
            <div className="container">
              <div className="row p-4">
                <div className="col col-login mx-auto p-4">
                <Route exact path="/login" component={LoginPage} />
                 <Route exact path="/forgot" component={ForgotPassword} />
                 <Route exact path="/reset" component={ResetPassword} />
                </div>
              </div>
            </div>
      </>
    );
}
export default withRouter(AuthComponent);